import React from 'react';
import { Col, Content, FlexboxGrid, Grid, Row, Stack, Text } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import FlowPageLayout from '../../components/layout/FlowPageLayout';
import { useSelector } from 'react-redux';
import {
  selectConfigExpressRegistrationVerbiage,
  selectConfigExpressRenewRequirements,
} from '../../store/slices/config/configSelectors';
import { constructMarkup } from '../../common/utils';
import { FLOWS_ENUM } from '../../common/enums';

const BulkRenewRequirements = () => {
  const selectedRequirements = useSelector(
    selectConfigExpressRenewRequirements
  );
  const permitName = useSelector(selectConfigExpressRegistrationVerbiage);

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={FLOWS_ENUM.BULK_RENEWAL} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content>
          <FlowPageLayout title="Renewal Requirements">
            <Grid
              className="mt-12 ml-0"
              fluid
            >
              <Row className="mb-32">
                <Col x={24}>
                  <Text>
                    Let's make sure you have everything you need to renew your{' '}
                    {permitName}.
                  </Text>
                </Col>
              </Row>
              {selectedRequirements &&
                Object.keys(selectedRequirements).map((requirement, idx) => {
                  let topMargin = idx === 0 ? '' : 'mt-24';
                  return (
                    <Row key={`content_section_${idx}`}>
                      <Col xs={24}>
                        <Stack
                          className={`text-bold mb-4 ${topMargin}`}
                          direction="row"
                          justifyContent="flex-start"
                        >
                          <Text className="mr-4">{idx + 1}.</Text>
                          <Text>
                            {constructMarkup(
                              selectedRequirements[requirement].title
                            )}
                          </Text>
                        </Stack>
                        {constructMarkup(
                          selectedRequirements[requirement].text
                        )}
                      </Col>
                    </Row>
                  );
                })}
            </Grid>
          </FlowPageLayout>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default BulkRenewRequirements;
